import * as types from '@/store/types'
import { DASHBOARD_ENTRY_ROUTE_NAME } from '@/constants/routes'
import { redirectToBackOrHome } from '@/utils/common'

// Создание сессии для просмотра аккаунта (для администратора сервиса)
export default async function createViewSession({
  to, from, next, store
}) {
  const profileId = to.query.account_id
  const firstLogin = to.query.first_login

  await store.dispatch(types.RESET_SESSION)
  store
    .dispatch(types.ADD_ACTION_IN_QUEUE, {
      type: types.CREATE_SESSION_FOR_VIEW,
      payload: { profileId, firstLogin },
      name: types.SESSION
    })
    .then(() => {
      const { currentlyViewProfile } = store.state[types.SESSION].model
      // Если ответ содержит тело
      if (currentlyViewProfile) {
        next({ name: DASHBOARD_ENTRY_ROUTE_NAME })
        return
      }

      // Возвращаем обратно, если возможно
      redirectToBackOrHome(from, next)
    })
    .catch(() => {
      // Возвращаем обратно, если возможно
      redirectToBackOrHome(from, next)
    })
}
